module.exports = __webpack_public_path__ + "img/camp05_open.c775c30b.png";